angular.module('SpidApp')

.controller('LoginController',
        ['BASE_PUBLIC_URL', '$scope', 'Restangular', '$state', '$window', '$localStorage', 'LoginService', '$rootScope', '$timeout', 'SynchroRun',
function (BASE_PUBLIC_URL,   $scope,   Restangular,   $state,   $window,   $localStorage,   LoginService,   $rootScope,   $timeout,   SynchroRun) {

	$scope.$storage = $localStorage;
	
	$scope.img 		= BASE_PUBLIC_URL + "/images/laposte_angular.png"
	$scope.marianne = BASE_PUBLIC_URL + "/images/marianne.jpg" 
	$scope.tampon 	= BASE_PUBLIC_URL + "/images/tampon.png"
	
	$scope.user = {
		username : null,
		password : null
	}
	$scope.error = {
		hasError : false,
		message  : null
	}
	
	// Lancement de la synchronisation
	SynchroRun.launchSync();

	$scope.animatedClass = 'bounceInLeft'
	$scope.login = function (username, password) {
		console.log('ROOTSCOPE SYNC : ' + $rootScope.isSyncRunning)
		if ( $rootScope.isSyncRunning )
		{
            console.log('SYNCHRO EN COURS, pas de login possible');
			return;
		}
		else
		{
            console.log('SYNCHRO TERMINEE, login ouvert');
		}


		LoginService.login(username, password).then(function(user) {
			if (user.n === 0) {
				throw 'User banned'
			}
			
			$localStorage.user = user
			user.setDefaultActiveRole()

			
			var destinationRoute = 'app'
			if (user.n > 0) {
				destinationRoute = 'app.password'
			}
			
			$scope.animatedClass = 'bounceOutRight'
			$timeout(function () {
				$state.go(destinationRoute);
			}, 750)
		  	
		}).catch(function (error) {
			$scope.error.hasError = true
			//$scope.error.message  = "Couple identifiant/mot de passe invalide"
			$scope.error.message  = "L’identifiant et le mot de passe que vous avez saisis ne correspondent pas"
				
			return error
		})
	}
	
	$scope.forgot = function() {
		
	};
}])
